import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class FollowUpsFormQuestionModel extends BaseModel {
  @attr("string") question;
  @attr("boolean") required;
  @attr("json") data;
  @attr("string") module;
  @attr("json") readOnly;
  @attr("json") schema;
}
